export default __webpack_public_path__ + "static/media/goods13.78b2cd63.gif";